import { Action } from '@ngrx/store';
import { NextWorkingDayResponseV5, RmsNextWorkingDayResponse } from '@cemex-core/cmx-api/models/next-working-day/next-working-day-res';

export enum CutOffActionTypes {
  LOAD = '[Rms Cut off] Load cut off',
  LOAD_V5 = '[Rms Cut off] Load cut off V5',
  LOAD_COMPLETE = '[Rms Cut off] Load cut off complete',
  RESET = '[Rms Cut off] Reset',
}

export class CutOffLoadAction implements Action {
  readonly type = CutOffActionTypes.LOAD;

  constructor() { }
}

export class CutOffLoadActionV5 implements Action {
  readonly type = CutOffActionTypes.LOAD_V5;

  constructor() { }
}

export class CutOffLoadCompleteAction implements Action {
  readonly type = CutOffActionTypes.LOAD_COMPLETE;

  constructor(public payload: RmsNextWorkingDayResponse | NextWorkingDayResponseV5) { }
}

export class CutOffResetAction implements Action {
  readonly type = CutOffActionTypes.RESET;

  constructor() { }
}

export type CutOffActions = CutOffLoadAction | CutOffLoadActionV5 | CutOffLoadCompleteAction | CutOffResetAction;
